import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import CustomAppBar from "../components/AppBar";
import api from "../globals/axios";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState();

  useEffect(() => {
    api.get("/farmer/profile").then((res) => {
      setProfileData(res.data);
      console.log(res.data);
    });
  }, []);

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Box>
              <Typography variant="h4">Profile</Typography>

              <Box component="form" sx={{ mt: 3 }}>
                <TextField
                  margin="normal"
                  fullWidth
                  label="Username"
                  value={profileData?.username || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  label="Name"
                  value={profileData?.first_name || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  label="Role"
                  value={profileData?.role || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(-1)}
                >
                  Go Back
                </Button>
              </Box>
              {/* <a target="_blank" href="https://app.newrl.net/request-new-wallet?public_key=1dedc241fecb7d0eea9ebf0334c26def87c0d9cbbde3d3c4dcd3bd35129a2a2056e8f3210b2e1905972ab4b74a5cceec1c33380221f460084aeac9c44d644d2d">KYC and Activate</a> */}
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
}
